<template>
  <div class="image-carousel">
    <div ref="imageCarousel" class="swiper image-carousel__wrapper">
      <div class="swiper-wrapper image-carousel__track">
        <slot></slot>
      </div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

export default {
  name: 'image-carousel',
  data() {
    return {
      carousel: null,
      carouselOptions: {
        modules: [Navigation, Pagination, Autoplay],
        slideClass: 'swiper-wrapper > *',
        slidesPerView: 1,
        watchOverflow: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 5000,
        },
        speed: 500,
        spaceBetween: 0,
      }
    }
  },
  methods: {
    initCarousel() {
      this.carousel = new Swiper(
        this.$refs.imageCarousel,
        this.carouselOptions
      )
    }
  },
  mounted() {
    this.initCarousel()
  }
}
</script>
